module.exports = __webpack_public_path__ + "img/bluefire-logo-final.ebaef525.png";